import { useEffect, useRef, useState } from "react";
import { useBidPrice } from "../../hooks/usePriceSubscription";
import { useTheme } from "../../theme/ThemeContext";

const Bid = ({ symbol, digits = 5, style }) => {
    const price = useBidPrice(symbol);
    const theme = useTheme();

    const prevPriceRef = useRef(null);
    const [direction, setDirection] = useState("same");

    useEffect(() => {
        if (typeof price !== "number") return;

        const prev = prevPriceRef.current;

        if (prev !== null) {
            if (price > prev) setDirection("up");
            else if (price < prev) setDirection("down");
            else setDirection("same");
        }

        prevPriceRef.current = price;
    }, [price]);

    const formatPrice = (value) => {
        if (typeof value !== "number" || isNaN(value)) {
            return (0).toFixed(digits);
        }
        return value.toFixed(digits);
    };

    const getBackgroundColor = () => {
        if (direction === "up") return theme.posBg;
        if (direction === "down") return theme.negBg;
        return theme.card2;
    };

    const getTextColor = () => {
        if (direction === "up") return theme.pos;
        if (direction === "down") return theme.neg;
        return theme.text;
    };

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4px 15px",
                borderRadius: 8,
                marginBottom: 4,
                backgroundColor: getBackgroundColor(),
            }}
        >
            <span
                // iwant to add style here but also allow passing custom style as prop
                style={{
                    ...style,
                    fontSize: 11,
                    fontFamily: theme.mono,
                    fontWeight: 600,
                    color: getTextColor(),
                    fontVariantNumeric: "tabular-nums",
                }}
            >
                {formatPrice(price)}
            </span>
        </div>
    );
};

export default Bid;
